
import state from '../data/state'

function filterImage(context) {

  var imageData = context.getImageData(0, 0, context.canvas.width, context.canvas.height);
  var data = imageData.data;

  for(var i = 0; i < data.length; i += 4) {

    let a = data[i + 3] / 255;

    // skip over transparent pixels
    if(a<.35) {
      data[i + 3] = 0;
      continue;
    }

    // Remove Alpha Chanel - Round to 0 or 255 (pixel on or off)
    data[i + 3] = 255;

    if(!state.colorDisplay) {

      // compute gray scale
      var brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];

      // convert to black and white
      brightness = Math.round( Math.pow(brightness / 255, 3)) * 255;

      // red
      data[i] = brightness;
      // green
      data[i + 1] = brightness;
      // blue
      data[i + 2] = brightness;
    }


  }

  // overwrite original image
  context.putImageData(imageData, 0, 0);
}

export default filterImage;



// WEBPACK FOOTER //
// ./src/util/filterImage.js